import { admin } from "common/config/Firebase"
import { getClientParams, saveClient, updateClientParams } from "../api"

const addClientUseCase = async(client) => {
    sanitazeObject(client)
    const { count } = await getClientParams()

    applyDefaultCreated(client, count)
    
    const increment = admin.firestore.FieldValue.increment(1)
    await updateClientParams({ count: increment })

    return saveClient(client)
}

const applyDefaultCreated = (client, count = 0) => {
    client.numberClient = count
    client.lastUpdated = new Date().getTime()
    if (client.iva === undefined || client.iva === "") client.iva = true
}

const sanitazeObject = client => {
    Object.keys(client).forEach(field => {
        if (typeof client[field] !== 'boolean' && typeof client[field] !== 'number') {
            client[field] = client[field] || ""
        }
    })
}

export default addClientUseCase